export const HOME = {
  emergentLink: "home-emergent-link",
  bookNowHero: "hero-book-now-btn",
  viewPackages: "hero-view-packages-btn",
  themeToggle: "theme-toggle-btn",
  navBookNow: "nav-book-now-btn",
  fab: "fab-book-now-btn",
  clickToCall: "click-to-call-btn",
  scrollTop: "scroll-to-top-btn",
  contactSubmit: "contact-submit-btn",
  contactName: "contact-name-input",
  contactEmail: "contact-email-input",
  contactPhone: "contact-phone-input",
  contactVehicle: "contact-vehicle-input",
  contactPackage: "contact-package-select",
  contactMessage: "contact-message-input",
  faqItem: (i) => `faq-item-${i}`,
  packageCard: (id) => `package-card-${id}`,
  packageSelectBtn: (id) => `package-select-${id}`,
  serviceCard: (i) => `service-card-${i}`,
  reviewCard: (i) => `review-card-${i}`,
  beforeAfterSlider: "before-after-slider",
};
